import { useState } from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import { bindEmail } from '../../../services/memberSettingsApi';
import { isTempEmail } from '../../../utils/email';
import './EmailBindingForm.css';

const RELOAD_DELAY_MS = 2000;

const EmailBindingForm = () => {
  const { user } = useAuth();
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState<{ type: 'success' | 'error'; text: string } | null>(null);

  // Only show form for users with temp email
  if (!user || !isTempEmail(user.email)) {
    return null;
  }

  const handleSubmit = async (e: React.SyntheticEvent) => {
    e.preventDefault();
    setMessage(null);

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setMessage({ type: 'error', text: '請輸入有效的電子郵件地址' });
      return;
    }

    setIsLoading(true);

    try {
      const result = await bindEmail(email);
      if (result.success) {
        setMessage({ type: 'success', text: '電子郵件綁定成功！請檢查您的收件匣以驗證電子郵件。' });
        setEmail('');
        // Update user data after binding
        if (result.data) {
          setTimeout(() => {
            window.location.reload();
          }, RELOAD_DELAY_MS);
        }
      } else {
        setMessage({ type: 'error', text: result.error?.message || '綁定失敗，請稍後再試' });
      }
    } catch {
      setMessage({ type: 'error', text: '網路錯誤，請稍後再試' });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="email-binding-form">
      <h3 className="email-binding-form__title">綁定電子郵件</h3>
      <p className="email-binding-form__description">
        您透過 LINE 登入但尚未綁定電子郵件。請輸入您的電子郵件地址以完成帳號設定。
      </p>

      {message && (
        <div className={`email-binding-form__alert email-binding-form__alert--${message.type}`}>
          {message.text}
        </div>
      )}

      <form onSubmit={handleSubmit} className="email-binding-form__form">
        <div className="email-binding-form__field">
          <label htmlFor="email-input">電子郵件地址 *</label>
          <input
            id="email-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="example@email.com"
            required
            disabled={isLoading}
          />
          <small>我們將發送驗證信到這個地址</small>
        </div>

        <button
          type="submit"
          className="email-binding-form__submit"
          disabled={isLoading || !email}
        >
          {isLoading ? '綁定中...' : '綁定電子郵件'}
        </button>
      </form>
    </div>
  );
};

export default EmailBindingForm;
